import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Contact.css"; // Import your CSS file if needed
import ContactForm from "./ContactForm";

const Contact = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <section id="contact" className="contact section">
      <div className="mb-5">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1835.5054285243095!2d87.31819299798917!3d23.060063539873!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f793d575a570e7%3A0x56d449d7df139c9!2sMallabhum%20Prayas!5e0!3m2!1sen!2sin!4v1617878466753!5m2!1sen!2sin"
          style={{ width: "100%", height: "400px" }}
          allowFullScreen
          title="Mallabhum Prayas Google Maps"
        ></iframe>
      </div>

      <div className="container">
        <div className="row gy-5 gx-lg-5" data-aos="fade">
          <div className="col-lg-4">
            <div className="info">
              <h3>Get in touch</h3>
              <p>
                For assistance, please feel free to reach out to us at your
                convenience.
              </p>

              <div className="info-item d-flex">
                <i className="bi bi-geo-alt flex-shrink-0"></i>
                <div>
                  <h4>Location:</h4>
                  <p>Gitarani Ghosh Smri Mandir</p>
                  <p>Kumaritaki More, PO- Bishnupur</p>
                  <p>District – Bankura, West Bengal, Pin – 722122</p>
                </div>
              </div>

              <div className="info-item d-flex">
                <i className="bi bi-envelope flex-shrink-0"></i>
                <div>
                  <h4>Email:</h4>
                  <p>mallabhumprayas@gmail.com</p>
                  <p>help@mallabhumprayas.org</p>
                </div>
              </div>

              <div className="info-item d-flex">
                <i className="bi bi-phone flex-shrink-0"></i>
                <div>
                  <h4>Call:</h4>
                  <p>+91 90643 12816</p>
                  <p>+91 83450 40440</p>
                </div>
              </div>
            </div>
          </div>
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default Contact;
